import { IModule } from 'redux-dynamic-modules';
import { eligibilityCheckSlice } from './eligibility-check.slice';
import {
  ELIGIBILITY_CHECK_SLICE_NAME,
  EligibilityCheckOwnState,
} from './eligibility-check.types';

export const getEligibilityCheckModule =
  (): IModule<EligibilityCheckOwnState> => ({
    id: ELIGIBILITY_CHECK_SLICE_NAME,
    reducerMap: {
      [ELIGIBILITY_CHECK_SLICE_NAME]: eligibilityCheckSlice.reducer,
    },
    retained: true,
  });
